import React, { Component } from "react";
import "../css/item.css";
import {Glyphicon, OverlayTrigger, Badge, Form} from 'react-bootstrap';
import {tooltip, toInt} from '../Utils';
import XLSX from 'xlsx';
import { ItemService } from "../Services/ItemService";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Modal from '@material-ui/core/Modal';
import Divider from '@material-ui/core/Divider';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
  
function getModalStyle() {
    const top = 50 ;
    const left = 50 ;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const styles = theme => ({
    fab: {
        margin: theme.spacing.unit,
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
        paddingTop : theme.spacing.unit, 
        paddingLeft: theme.spacing.unit, 
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    margin: {
        margin: theme.spacing.unit,
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        outline: 'none',
    },
    table: {
        // overflowX: 'auto',
        // display: 'block'
        minWidth: 500
    },
  });

class Item extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        originalData: [],
        rows: [],
        show: false,
        new_item: { name: "", unit_size: "", stock: 0, threshold: 0},
        sheet: "Items",
        filename: "Item List",
      }

      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.edit = this.edit.bind(this);
      this.updateRows = this.updateRows.bind(this);
      this.export = this.export.bind(this);
    }

    confirmSave = () => {
        this.handleClose();
        this.props.closeConfirmDialog();
        this.createItemAPI(this.state.new_item);
    }

    createModifyItem = (e) => {
        e.preventDefault();
        if(this.state.new_item.name && this.state.new_item.unit_size && this.state.new_item.threshold >= 0){
            this.props.showConfirmDialog("Confirm?", undefined, this.confirmSave);
        } else {
            this.props.showSnackBar('Please fill all the details and continue', 'error');
        }
    }

    createItemAPI(new_item){
        new_item.threshold = toInt(new_item.threshold);
        let body = new_item;
        this.props.isLoading(true);
        let headers = {user_id : this.props.user.id };
        ItemService.create(headers, body)
        .then((response) => {
            if(response.status === 409){
                this.props.showSnackBar(`${new_item.name} already exists.`, 'error');
            } else {
                this.setState({
                    new_item: { name: "", unit_size: "", stock: 0, threshold: 0}
                });
                this.fetchData();
                if(this.state.show) this.handleClose();
                this.props.isLoading(false);
                this.props.showSnackBar(`${new_item.id ? 'Saved' : 'Created'} Item: ${new_item.name}`, 'success');
            }
        })
        .catch(() => {
            this.props.isLoading(false);
            this.props.showConfirmDialog(`Failed to create item : ${new_item.name}. Please try again.`, undefined, undefined);
        });
        
    }

    edit(e, item){
        e.preventDefault();
        if(item){
            this.setState({new_item: {id: item.id, name: item.name, unit_size: item.unit_size, threshold: item.threshold}}, function () {
                this.handleShow();
            });
        } else {
            this.setState({show: true});
        }
    }
    componentWillMount(){
        this.props.setTitle("Items");
    }
 
    componentDidMount(){
        this.fetchData();
    }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            new_item: { name: "", unit_size: "", stock: 0, threshold: 0}
        });
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleChange = (e) => {
        e.preventDefault();
        let change = this.state.new_item;
        change[e.target.name] = e.target.value;
        this.setState(change);        
    }


    fetchData(){
        this.props.isLoading(true);
        ItemService.getItemList()
        .then((data) => {
            this.setState({data: data.items,  originalData: data.items});
            this.filterCriteria();
            this.props.isLoading(false);
        })
        .catch(error => {
            console.error(error);
            this.props.isLoading(false);
        });
    }

    updateRows(data){
        let rows = [];
        data.forEach((item) => {
            rows.push(<ItemDetails key={item.id} item={item} remove={this.remove} edit={this.edit}/>);
          });
        this.setState({rows: rows});
    }

    export(e){
        e.preventDefault();
        let exportData = [["SL.NO", "NAME", "Unit of Measure", "STOCK", "THRESHOLD"]];
        this.props.isLoading(true);

        this.state.originalData.forEach((prod, index) => {
            let prodArray = [index + 1, prod.name, prod.unit_size, prod.stock, prod.threshold];
            exportData.push(prodArray)
        });

        const wb = XLSX.utils.book_new();
        const wsAll = XLSX.utils.aoa_to_sheet(exportData);
        XLSX.utils.book_append_sheet(wb, wsAll, this.state.sheet.substring(0, 30));
        XLSX.writeFile(wb, this.state.filename + ".xlsx");

        this.props.isLoading(false);
    }

    filterCriteria(e){
        this.props.isLoading(true);
        if(e)
            e.preventDefault();
        const searchText = this.refs.inputText.value;
        let filteredList = this.state.originalData.filter(data => data.name.toLowerCase().includes(searchText.toLowerCase()));
        if(this.refs.inputText.value.length === 0){
            filteredList = this.state.originalData;
        }
        this.setState({
            data: filteredList,
            message: filteredList.length > 0 ? '' : 'No matching Item'
        });
        this.updateRows(filteredList);
        this.props.isLoading(false);
    }

    remove = (e, id) => {
        e.preventDefault();
        if(id) {
            this.props.showConfirmDialog("This will not effect any of the existing Projects.", "Confirm removal of Item?", () => {
                let headers = {user_id : this.props.user.id };
                ItemService.remove(headers, id)
                .then(() =>{
                    this.fetchData();
                    this.props.closeConfirmDialog();
                    this.props.showSnackBar(`Removed Item`, 'success');
                })
                .catch((error) => {
                    this.props.showSnackBar(`Failed to remove Item. Please try again.`, 'error');
                });
            });
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <div className="Home">
                <h3 style={{marginBottom: '5px'}}>Items <Badge>{this.state.data.length}</Badge></h3>
                <div className="container">
                    <Paper className={classes.root} style={{paddingTop : '15px', paddingLeft: "5px", paddingRight: "5px", marginTop: '10px'}}>
                        <form onSubmit={(e) => this.filterCriteria(e)} ref="searchForm">
                            <input ref="inputText" type="text" name="searchText" placeholder="Search" onChange={(e) => this.filterCriteria(e)} style={{width: "100%", marginBottom: "10px", padding: "5px", borderColor:"red"}} autoComplete="off"></input>
                        </form>
                        <Table className={classes.table}>
                            <TableHead>
                            <TableRow>
                                <TableCell><Typography variant="title">Name</Typography></TableCell>
                                <TableCell align="center"><Typography variant="title">Unit of Measure</Typography></TableCell>
                                <TableCell alignnopm="center"><Typography variant="title">Stock</Typography></TableCell>
                                <TableCell align="center"><Typography variant="title">Threshold</Typography></TableCell>
                                <TableCell align="center"></TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.rows}
                            </TableBody>
                        </Table>
                    </Paper>
                </div>
                <Modal 
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.show} 
                    onClose={this.handleClose}>
                    <div style={getModalStyle()} className={classes.paper}>
                        <Typography variant="h6" id="modal-title">
                            { this.state.new_item.id ? 'Modify Item' : 'Create Item' }
                        </Typography>
                        <Divider />
                        {this.itemForm(this.createModifyItem, "Save")}
                    </div>
                </Modal>
                <OverlayTrigger placement="top" overlay={tooltip("Add Item")} >
                    <Fab onClick={this.edit} color="primary" aria-label="Add" className={classes.fab}>
                        <AddIcon />
                    </Fab>
                </OverlayTrigger>
            </div>
        );
    }

    itemForm = (submitFunction, buttonText, orientation) => (
        <Form {...orientation} className="" onSubmit={submitFunction}>
            <TextField
                id="name"
                label="Item Name"
                placeholder="Item Name"
                name="name"
                defaultValue={this.state.new_item.name}
                className={this.props.classes.textField}
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                required
                />
            <TextField
                id="unit_size"
                label="Unit of Measure"
                defaultValue={this.state.new_item.unit_size}
                placeholder="Unit of Measure"
                name="unit_size"
                className={this.props.classes.textField}
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                required
                />
            <TextField
                id="threshold"
                className={this.props.classes.textField}
                variant="outlined"
                label="Threshold"
                margin="normal"
                defaultValue={this.state.new_item.threshold}
                name="threshold"
                onChange={this.handleChange}
                pattern="[0-9]*"
                type="number"
                InputProps={{
                    inputProps: { min: 0 }
                }}
                required
                />
            <br/>
            <div style={{marginTop: "10px", marginLeft: "8px"}}>
                <Button variant="outlined" size="medium" color="primary" type="submit" onClick={submitFunction} style={{marginRight: "10px"}}>{buttonText}</Button>
                {!this.state.show ? (<Button type="submit" variant="contained" size="medium" color="primary" onClick={this.export} style={{marginRight: "10px"}}>Export</Button>): ""}
                {this.state.show ? (<Button variant="outlined" size="medium" color="primary" onClick={this.handleClose}>Close</Button>): ""}
            </div>
        </Form>
    )

}

class ItemDetails extends Component {

    render(){
      const item = this.props.item;
      return (
        <TableRow key={item.id}>
            <TableCell component="th" scope="row">
                {item.name}
            </TableCell>
            <TableCell align="center">{item.unit_size}</TableCell>
            <TableCell align="center">{item.stock}</TableCell>
            <TableCell align="center">{item.threshold}</TableCell>
            <TableCell align="right">
                <OverlayTrigger placement="bottom" overlay={tooltip("Edit")} >
                    <Glyphicon style={{marginRight: "20px"}} glyph="pencil" onClick={(e) => this.props.edit(e, item)}/>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={tooltip("Remove Item")}>
                    <Glyphicon style={{marginRight: "10px"}} glyph="trash" onClick={(e) => this.props.remove(e, item.id)}/>
                </OverlayTrigger>
            </TableCell>
        </TableRow>
      );
    }
}

export default withStyles(styles)(Item);